import { Component, Inject, Input, OnDestroy, OnInit, Optional, ViewChild, input } from '@angular/core';
import { NgForm } from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CurrencyPipe } from '../../../shared/pipes/currency.pipe';

@Component({
  selector: 'reit-modify',
  standalone: false,
  templateUrl: './modify.component.html',
  styleUrl: './modify.component.scss'
})
export class ReitModifyComponent implements OnInit, OnDestroy {

  @ViewChild('modifyForm', { static: true }) modifyForm: NgForm | undefined
  errorMessage!: string

  public reit: any

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ReitModifyComponent>,
    private currencyPipe: CurrencyPipe
  ) {
    console.error('ReitModifyComponent -> constructor', data)
    this.reit = data
  }

  ngOnInit(): void {
    console.error('ReitModifyComponent -> ngOnInit')

    //Update total
    this.modifyForm?.valueChanges?.subscribe((input:any) => {
      // console.error('ReitCreateComponent -> createForm.valueChanges', input)
      
      if(input['reit.amount'] != undefined && input['reit.price'] != undefined)
        this.reit.total = (input['reit.amount'] * parseFloat(this.currencyPipe.transform(input['reit.price'], false))).toFixed(2)
    })
  }

  ngOnDestroy(): void {
    console.warn('ReitModifyComponent -> ngOnDestroy')
  }

  onSubmit(): void {
    console.error('ReitModifyComponent -> onSubmit', this.modifyForm?.value);

    if (this.modifyForm?.valid)
      this.dialogRef.close({
        data: {
          response: 'Reit modified!',
          values:  { 
            ...this.reit, 
            amount: this.modifyForm.value['reit.amount'].toString(), 
            price: parseFloat(this.currencyPipe.transform(this.modifyForm.value['reit.price'], false)),
            total: parseFloat(this.currencyPipe.transform(this.modifyForm.value['reit.total'], false)),
          }
        }
      })
    else
      this.errorMessage = "Errorrrrr"
  }
}
